// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__36LJ1","container":"styles_container__1BVJG","title":"styles_title__FgApY","wrapper":"styles_wrapper__17OHl","answer":"styles_answer__3ihqi"};